/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".footer.fixed[_ngcontent-%COMP%]{position:fixed}.technical[_ngcontent-%COMP%]{font-size:10px}"];
export { styles as styles };
